<template>
  <el-dialog
    :title="$t('shareReading.batchAudit.title')"
    :visible.sync="dialogVisible"
    width="40%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('shareReading.add.readingPeriod')" prop="readingPeriod">
        <el-date-picker
          v-model="form.readingPeriod"
          type="month"
          value-format="yyyy-MM"
          :placeholder="$t('shareReading.add.selectReadingPeriod')"
          style="width:100%"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { batchAuditFloorShareReading } from '@/api/fee/shareReadingApi'

export default {
  name: 'BatchAuditShareReading',
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      form: {
        readingPeriod: '',
        communityId: ''
      },
      rules: {
        readingPeriod: [
          { required: true, message: this.$t('shareReading.validate.selectReadingPeriod'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.submitting = true
            this.form.communityId = getCommunityId()
            await batchAuditFloorShareReading(this.form)
            this.$message.success(this.$t('shareReading.message.batchAuditSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('批量审核公摊抄表失败:', error)
            this.$message.error(error.message || this.$t('shareReading.message.batchAuditFailed'))
          } finally {
            this.submitting = false
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {
        readingPeriod: '',
        communityId: ''
      }
    }
  }
}
</script>
